<!--
 * @Author: your name
 * @Date: 2021-05-15 22:04:43
 * @LastEditors: 聪Cong
 * @LastEditTime: 2022-07-10 15:02:42
 * @FilePath: /卫星/weixing/src/App.vue
-->
<template>
  <div id="app">
    <div id="nav">
      <router-link to="/"> 
        <Button v-on:click="jiaodu" type="success" v-bind:ghost = "router.jiaodu">卫星角度计算</Button>
      </router-link> |
      <router-link to="/dbmToW">
         <Button v-on:click="gonglv" type="success" v-bind:ghost = "router.gonglv">聪聪工具包</Button>
      </router-link> |
      <router-link to="/help">
        <Button v-on:click="help" type="success"  v-bind:ghost = "router.help">帮助</Button>
      </router-link> 
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: {
        //路由
        jiaodu: false, //角度计算
        gonglv: true, //功率计算
        help: true, //帮助
      }
    };
  },
  methods: {
    jiaodu()
    {
      this.router.jiaodu=false;
      this.router.gonglv=true;
      this.router.help=true;
    },
    gonglv()
    {
      this.router.jiaodu=true;
      this.router.gonglv=false;
      this.router.help=true;
    },
    help()
    {
      this.router.jiaodu=true;
      this.router.gonglv=true;
      this.router.help=false;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
